import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import io from 'socket.io-client';

import Dashboard from './pages/Dashboard';
import Campaigns from './pages/Campaigns';
import CampaignDetail from './pages/CampaignDetail';
import Contacts from './pages/Contacts';
import WhatsAppStatus from './pages/WhatsAppStatus';
import Blacklist from './pages/Blacklist';
import Inbox from './pages/Inbox';
import Monitoring from './pages/Monitoring';
import Network from './pages/Network';

// Initialize Socket.io
const socket = io(process.env.REACT_APP_API_URL || 'http://localhost:5000');

function NavBar() {
  const location = useLocation();
  const [currentTime, setCurrentTime] = useState(new Date());
  const [unreadCount, setUnreadCount] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Listen for new messages
    socket.on('new-message', (data) => {
      toast.info(`New message from ${data.phoneNumber}`, {
        position: "top-right",
        autoClose: 5000
      });
      setUnreadCount(prev => prev + 1);
    });

    socket.on('message-receipt', (data) => {
      if (data.status === 4) {
        toast.success(`Message read by ${data.phoneNumber}`);
      }
    });

    return () => {
      socket.off('new-message');
      socket.off('message-receipt');
    };
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);
  
  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };
  
  const formatTime = (date) => {
    return date.toLocaleString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  
  return (
    <div className="navbar">
      <div className="navbar-content">
        <div>
          <h1>📱 WhatsApp Campaign Manager</h1>
          <div style={{ fontSize: '12px', opacity: 0.9, marginTop: '2px' }}>
            🕐 {formatTime(currentTime)}
          </div>
          <button className="menu-toggle" onClick={toggleMobileMenu} aria-label="Toggle menu">
            {mobileMenuOpen ? '✕' : '☰'}
          </button>
        </div>
        <nav className={mobileMenuOpen ? 'mobile-menu-open' : ''}>
          <Link to="/" className={isActive('/')}>Dashboard</Link>
          <Link to="/campaigns" className={isActive('/campaigns')}>Campaigns</Link>
          <Link to="/contacts" className={isActive('/contacts')}>Contacts</Link>
          <Link to="/network" className={isActive('/network')}>Network</Link>
          <Link to="/inbox" className={isActive('/inbox')}>
            Inbox {unreadCount > 0 && <span className="badge-notification">{unreadCount}</span>}
          </Link>
          <Link to="/blacklist" className={isActive('/blacklist')}>Blacklist</Link>
          <Link to="/monitoring" className={isActive('/monitoring')}>Monitoring</Link>
          <Link to="/whatsapp" className={isActive('/whatsapp')}>WhatsApp</Link>
        </nav>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/campaigns" element={<Campaigns />} />
          <Route path="/campaigns/:id" element={<CampaignDetail />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/network" element={<Network />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="/blacklist" element={<Blacklist />} />
          <Route path="/monitoring" element={<Monitoring />} />
          <Route path="/whatsapp" element={<WhatsAppStatus />} />
        </Routes>
        <ToastContainer />
      </div>
    </Router>
  );
}

export { socket };
export default App;
